import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=efefdbc2&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efefdbc2",
  null
  
)

export default component.exports